module.exports = __webpack_public_path__ + "static/media/cwc-clientside-logo.297316e6.png";